var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconInfo = function SvgIconInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 0C4.486 0 0 4.486 0 10s4.486 10 10 10 10-4.486 10-10S15.514 0 10 0ZM9 4.997C9 4.447 9.448 4 10 4s1 .447 1 .997v.499c0 .55-.448.997-1 .997s-1-.446-1-.997v-.499Zm-2 3.49c0 .552.448.998 1 .998h1v3.99H8c-.552 0-1 .446-1 .997 0 .55.448.997 1 .997h4c.552 0 1-.446 1-.997a.999.999 0 0 0-1-.997h-1V8.488a.999.999 0 0 0-1-.997H8c-.552 0-1 .446-1 .997Z"
  })));
};
export default SvgIconInfo;